import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RefundCompletedDTO, RefundRequestDTO} from '@features/payment/domain/model/refund.model';
import {RefundStrategy} from '@features/payment/domain/ports/strategy/refund-strategy.port';
import {InvoicesGateway} from '@features/payment/infrastructure/gateways/invoices.gateway';

@Injectable({providedIn: 'root'})
export class InvoiceRefundStrategy implements RefundStrategy {
  private readonly invoicesGateway = inject(InvoicesGateway);

  refund(request: RefundRequestDTO): Observable<RefundCompletedDTO> {
    return this.invoicesGateway.refund(request);
  }
}
